import { useCallback } from "react";
import axios from "../api/axios";
import useAuth from "./useAuth";

/**
 * Stable refresh function — must not change identity every render, or hooks that
 * depend on it (e.g. useResibotApi → request) will re-run useEffects in an infinite loop.
 */
const useRefreshToken = () => {
  const { setAuth } = useAuth();

  const refresh = useCallback(async () => {
    const response = await axios.get("/refresh", {
      withCredentials: true,
    });
    setAuth((prev) => {
      const u = response.data.username ?? response.data.user;
      return {
        ...prev,
        user: u ?? prev.user,
        username: u ?? prev.username,
        role: response.data.role,
        accessToken: response.data.accessToken,
        resiWeb: response.data.resiWeb,
        resiCal: response.data.resiCal,
      };
    });
    return response.data.accessToken;
  }, [setAuth]);

  return refresh;
};

export default useRefreshToken;